import React, { memo, useCallback, useState } from "react";
import { Button } from "primereact/button";
import { Dropdown } from "primereact/dropdown";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { getFieldName } from "src/utils/helpers";
import {
  resetFilterData,
  setFilterDataField,
  setGridCurrentPageInvoice,
} from "src/redux/slices/invoiceSlice";
import { InputText } from "primereact/inputtext";
import FilterActionButtons from "src/components/FilterActionButtons/FilterActionButtons";
import ToggleFilter from "src/components/ToggleFilter/ToggleFilter";
import useResize from "src/hooks/useResize";
import { isSelectedFilterStatusIsCompleted } from "src/utils/common";
import { setChangeHistoricalDataSource } from "src/redux/slices/sharedSlice";
import { showHistoricalDataChangeSource } from "src/resources/enum";

const InvoicesFilter = memo(() => {
  const dispatch = useDispatch();
  const { t } = useTranslation(["common", "registration", "invoice"]);
  const { isMobile } = useResize();
  const [isFilterShown, setIsFilterShown] = useState(!isMobile);

  const { paymentStatus, assignedBuildingId, propertyNumber, invoiceNumber } =
    useSelector((state: any) => state.invoices.filterData);
  const handleFormSubmit = (e: any) => {
    e.preventDefault();
  };
  const { invoiceStatusOptions, buildingsForInvoices, language } = useSelector(
    (state: any) => state.lookup
  );

  const handleFilter = () => {
    goToGridFirstPage();
  };

  const goToGridFirstPage = useCallback(() => {
    dispatch(setGridCurrentPageInvoice(0) as any);
  }, []);

  const handleFormFieldChange = (e: any) => {
    let name, value;
    if (e.target) {
      name = e.target.name;
      value = e.target.value;
    } else {
      name = e.name;
      value = e.value;
    }
    dispatch(setFilterDataField({ field: name, value }));
    if (name === "paymentStatus") {
      dispatch(setChangeHistoricalDataSource(showHistoricalDataChangeSource.Invoice));
      dispatch(setFilterDataField({ field: "showHistoricalData", value: isSelectedFilterStatusIsCompleted(invoiceStatusOptions, value) }));
    }
  };

  const handleClearFilterForm = (): void => {
    dispatch(resetFilterData());
    goToGridFirstPage();
  };

  const toggleFilter = () => {
    setIsFilterShown(!isFilterShown);
  };
  return (
    <>
      <ToggleFilter onClick={toggleFilter} />
      <div
        className={`pt-3 pb-2 px-2 maintenance-requests-filter assigned-buildings-filter ${!isMobile || isFilterShown ? "d-flex" : "d-none"
        }`}
      >
        <p className="d-flex m-0 me-2 ms-2 mb-2 align-items-center fit-content filter-by-label">
          {t("filterBy")}
        </p>
        <form onSubmit={handleFormSubmit}>
          <div className="filter-row mb-2">
            <InputText
              type="text"
              placeholder={t("invoiceNo")}
              onChange={handleFormFieldChange}
              value={invoiceNumber}
              name="invoiceNumber"
            />
            <Dropdown
              filter
              resetFilterOnHide
              emptyFilterMessage={t("noResultsFound")}
              id="singlePaymentStatus"
              options={invoiceStatusOptions}
              placeholder={t("invoiceStatus")}
              className="status-dropdown"
              panelClassName="status-dropdown-panel"
              onChange={handleFormFieldChange}
              value={paymentStatus}
              optionValue={"id"}
              optionLabel={getFieldName(language)}
              name="paymentStatus"
            />
            <Dropdown
              filter
              resetFilterOnHide
              emptyFilterMessage={t("noResultsFound")}
              id="singleAssignedBuildingId"
              options={buildingsForInvoices}
              placeholder={t("filterByBuilding")}
              className="status-dropdown"
              panelClassName="status-dropdown-panel"
              onChange={handleFormFieldChange}
              value={assignedBuildingId}
              optionValue={"propertyId"}
              optionLabel={"buildingName"}
              name="assignedBuildingId"
            />
            <InputText
              type="text"
              placeholder={t("propertyID")}
              onChange={handleFormFieldChange}
              value={propertyNumber}
              name="propertyNumber"
            />

            <FilterActionButtons
              handleFilter={handleFilter}
              handleClear={handleClearFilterForm}
            />
          </div>
        </form>
      </div>
    </>
  );
});

export default InvoicesFilter;
